import { makeAutoObservable } from 'mobx';

// Recurring payments intentionally has its own store, rather than being part of PaymentStore.
class RecurringPaymentStore {
  isFetching = false;
  isInitialized = false;
  hasRecurringPayment = false;
  recurringPaymentDetails?: any = undefined;
  needToUpdate = false;
  hasConnectedService = false;

  constructor() {
    makeAutoObservable(this);
  }

  changeIsFetching(value: boolean) {
    this.isFetching = value;
  }

  changeRecurringPaymentDetails(value?: any) {
    this.hasRecurringPayment = !!value;
    this.recurringPaymentDetails = value;
    this.isInitialized = true;

    if (this.needToUpdate) {
      this.needToUpdate = false;
    }

    this.changeIsFetching(false);
  }

  changeNeedToUpdate(value: boolean) {
    this.needToUpdate = value;
  }

  changeHasConnectedService(value: boolean) {
    this.hasConnectedService = value;
  }
}

export default RecurringPaymentStore;